import { useEffect, useState } from 'react';
import {
  getOnlineStatus,
  subscribeOnlineStatus,
} from '../platform/online-status';

/**
 * React hook for the online/offline state. Components that need to disable
 * controls or show a banner read this rather than `navigator.onLine` so they
 * benefit from the active health-probe loop.
 */
export function useOnlineStatus(): boolean {
  const [online, setOnline] = useState<boolean>(() => getOnlineStatus().online);
  useEffect(() => subscribeOnlineStatus(setOnline), []);
  return online;
}
